module.exports = __webpack_public_path__ + "img/box3.86cd137b.png";